
const enums = { 'CANCELLED': { 'text': 'Cancelled', 'value': 7 },
  'CONFIRMED': { 'text': 'Confirmed', 'value': 2 },
  'FULFILLED': { 'text': 'Fulfilled', 'value': 5 },
  'IN_PRODUCTION': { 'text': 'In production', 'value': 3 },
  'ON_HOLD': { 'text': 'On hold', 'value': 6 },
  'PARTIALLY_FULFILLED': { 'text': 'Partially Fulfilled', 'value': 4 },
  'PENDING': { 'text': 'Pending', 'value': 1 }}
export default enums
